export const hourlyHourForecastTileTestIDs = {
  hourText: 'hourly_weather_forecast_hour_tile_hour_text',
  dayText: 'hourly_weather_forecast_hour_tile_day_text',
  icon: 'hourly_weather_forecast_hour_tile_icon',
  tempText: 'hourly_weather_forecast_hour_tile_temp_text',
  precipLabel: 'hourly_weather_forecast_hour_tile_precip_label',
  precipText: 'hourly_weather_forecast_hour_tile_precip_text',
};
